const baseUrl = window.location.origin;
const APP_URL = `${baseUrl}/apps/alimed-theme`;

//Custom Error Message if Email and Phone number already exists
const ACCOUNT_EXIST_MESSAGE = `
  <li>If you’ve signed in before — or placed an order using this contact information — please log in instead. 
  You can do this by selecting <b>"My Account"</b> in the upper right corner and entering your email to receive a login code.</li>
  <li>Want to create a separate new account? Please use a different email address and/or phone number not previously used with AliMed.</li>
`;

document.addEventListener('DOMContentLoaded', function () {
  initializeEventListeners();
});

function initializeEventListeners() {
  // Event listener for the company-associated selection
  const companyAssociatedYes = document.getElementById('company_associated_yes');
  if (companyAssociatedYes) {
    companyAssociatedYes.addEventListener('change', handleCompanyAssociatedYesSelection);
  } 
  
  // Event listener for the continue button
  const continueButton = document.getElementById('account__continue-btn');
  if (continueButton) {
    continueButton.addEventListener('click', handleContinueButtonClick);
  }
  
  // Event listener for the B2C create account button
  const createB2CAccountButton = document.getElementById('create-account-btn');
  if (createB2CAccountButton) {
    createB2CAccountButton.addEventListener('click', handleCreateB2CAccountButtonClick);
  }

  // Event listener for the search button (for B2B section)
  const searchButton = document.getElementById('find-company-button');
  if (searchButton) {
    searchButton.addEventListener('click', handleCompanySearch);
  }

  // Event listener for the B2B existing company create account button
  const B2BExistCompanyAccountBtn = document.getElementById('B2B-Exist-Company-Create-Btn');
  if (B2BExistCompanyAccountBtn) {
    B2BExistCompanyAccountBtn.addEventListener('click', handleCreateB2BExistCompanyAccountBtnClick);
  }

  // Event listener for the B2B new company create account button
  const B2BNewCompanyCreateAccountBtn = document.getElementById('B2B-New-Company-Create-Btn');
  if (B2BNewCompanyCreateAccountBtn) {
    B2BNewCompanyCreateAccountBtn.addEventListener('click', handleCreateB2BNewCompanyAccountBtnClick);
  }

  // Event listener for the company-alimed selection
  const companyAlimedYes = document.getElementById('company_alimed_yes');
  const companyAlimedNo = document.getElementById('company_alimed_no');
  
  if (companyAlimedYes) {
    companyAlimedYes.addEventListener('change', handleCompanyAlimedYesSelection);
  } 
  if (companyAlimedNo) {
    companyAlimedNo.addEventListener('change', handleCompanyAlimedNoSelection);
  }
  
  // Event listener for the B2B Add Company Info button
  const B2BAddCompanyInfoBtn = document.getElementById('B2B-Add-Company-Info-Btn');
  if (B2BAddCompanyInfoBtn) {
    B2BAddCompanyInfoBtn.addEventListener('click', handleCreateB2BAddCompanyInfoBtnClick);
  }
  dynamicB2BCountryStateUpdate();
  dynamicB2BCountryStateBillingUpdate();
}

// Handle the continue button click for both "company_associated" and "company_alimed"
function handleContinueButtonClick(event) {
  event.preventDefault(); // Prevent form submission

  const companyAssociatedYes = document.getElementById('company_associated_yes');
  const companyAssociatedNo = document.getElementById('company_associated_no');
  const companyAlimedYes = document.getElementById('company_alimed_yes');
  const continueButton = document.getElementById('account__continue-btn');

  // If company_associated is "No"
  if (companyAssociatedNo && companyAssociatedNo.checked) {
    showB2CAccountCreationSection();
  }

  // If company_associated is "Yes"
  if (companyAssociatedYes && companyAssociatedYes.checked) {
    showCompanyAlimedSection();
  }
}

//Handle the continue button click for both "company_associated"
function handleCompanyAssociatedYesSelection() {
  document.getElementById('B2C-Account-Create').classList.add('hidden');
  document.getElementById('account__continue-btn').classList.remove('hidden');
}

/*
* Create an Account B2C
*/

// Dynamic B2C Country and State Update
function dynamicCountryStateUpdate() {
  let countrySelect = document.getElementById('shipping_country');
  let stateInputGroup = document.querySelector('.form-group__state');
  let dynamicStateGroup = document.querySelector('.form-group__dynamic-state');
  let dynamicStateSelect = document.getElementById('shipping_state');

  // Function to handle country selection change
  countrySelect.addEventListener('change', function () {
    let selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    let statesData = selectedCountry.getAttribute('data-states');
    
    if (statesData && statesData !== '[]') {
      // There are states for this country, show dynamic state select
      stateInputGroup.classList.add('hidden');
      dynamicStateGroup.classList.remove('hidden');

      // Parse the states data from the attribute
      try {
        let states = JSON.parse(statesData);
        
        // Clear existing options
        dynamicStateSelect.innerHTML = '<option value="">Select State</option>';

        // Populate the dynamic state select dropdown
        states.forEach(function(state) {
          let option = document.createElement('option');
          option.value = state.state_name;
          option.textContent = state.state_name;
          option.setAttribute('data-state-zone-code', state.state_zone_code);
          dynamicStateSelect.appendChild(option);
        });
      } catch (e) {
        console.error('Error parsing state data:', e);
      }
    } else {
      // No states for this country, show text input for state
      stateInputGroup.classList.remove('hidden');
      dynamicStateGroup.classList.add('hidden');
      dynamicStateSelect.innerHTML = '<option value="">Select State</option>'; // Clear the select options
    }
  });

  // Trigger change event on page load to handle default country
  if (countrySelect.value) {
    countrySelect.dispatchEvent(new Event('change'));
  }
}

// Dynamic B2C Billing Country and State Update
function dynamicBillingCountryStateUpdate() {
  let countrySelect = document.getElementById('b2c-billing-dynamic-country');
  let stateInputGroup = document.querySelector('.form-group__billing-state');
  let dynamicStateGroup = document.querySelector('.form-group__dynamic-billing-state');
  let dynamicStateSelect = document.getElementById('b2c-billing-dynamic-state');

  // Function to handle country selection change
  countrySelect.addEventListener('change', function () {
    let selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    let statesData = selectedCountry.getAttribute('data-states');
    
    if (statesData && statesData !== '[]') {
      // There are states for this country, show dynamic state select
      stateInputGroup.classList.add('hidden');
      dynamicStateGroup.classList.remove('hidden');

      // Parse the states data from the attribute
      try {
        let states = JSON.parse(statesData);
        
        // Clear existing options
        dynamicStateSelect.innerHTML = '<option value="">Select State</option>';

        // Populate the dynamic state select dropdown
        states.forEach(function(state) {
          let option = document.createElement('option');
          option.value = state.state_name;
          option.textContent = state.state_name;
          option.setAttribute('data-state-zone-code', state.state_zone_code);
          dynamicStateSelect.appendChild(option);
        });
      } catch (e) {
        console.error('Error parsing state data:', e);
      }
    } else {
      // No states for this country, show text input for state
      stateInputGroup.classList.remove('hidden');
      dynamicStateGroup.classList.add('hidden');
      dynamicStateSelect.innerHTML = '<option value="">Select State</option>'; // Clear the select options
    }
  });

  // Trigger change event on page load to handle default country
  if (countrySelect.value) {
    countrySelect.dispatchEvent(new Event('change'));
  }
}

// Show the B2C account creation section
function showB2CAccountCreationSection() {
  const continueButton = document.getElementById('account__continue-btn');
  const b2cSection = document.getElementById('B2C-Account-Create');

  continueButton.classList.add('hidden');
  if (b2cSection) {
    b2cSection.classList.remove('hidden');

    // B2C billing form details
    const billingCheckbox = document.getElementById('billing_updates');
    const billingDetails = document.getElementById('B2C-Billing-Details');
  
    // Add an event listener for the B2C Billing checkbox change
    billingCheckbox.addEventListener('change', function() {
      if (this.checked) {
        // Hide the billing form if checkbox is checked
        billingDetails.classList.add('hidden');
      } else {
        // Show the billing form if checkbox is unchecked
        billingDetails.classList.remove('hidden');
      }
      dynamicBillingCountryStateUpdate();
    });
    dynamicCountryStateUpdate();
  }
}

// Function to disable the Create Account Button and show loading text
function disableButtonWithLoading(button) {
  button.disabled = true; // Disable the button
  button.innerHTML = 'Loading...'; // Change button text to "Loading..."
}

// Function to enable the Create Account Button and restore original text
function enableButton(button) {
  button.disabled = false; // Enable the button
  button.innerHTML = 'Create Account'; // Restore original text (or change based on your button label)
}

// B2C Collect User Form Data 
function collectB2CFormData() {
  const formData = {
    customerCreate: true,
    email: document.getElementById('email')?.value,
    title: document.getElementById('title')?.value,
    first_name: document.getElementById('first_name')?.value,
    last_name: document.getElementById('last_name')?.value,
    contact: document.getElementById('contact')?.value,
    promo_updates: document.getElementById('promo_updates')?.checked ? "SUBSCRIBED" : "NOT_SUBSCRIBED",
    shipping_address: document.getElementById('shipping_address')?.value,
    shipping_address2: document.getElementById('shipping_address2')?.value,
    shipping_country: document.getElementById('shipping_country')?.value,
    shipping_state: document.getElementById('shipping_state').value || document.getElementById('state').value,
    shipping_state_zone_code: document.querySelector('#shipping_state option:checked')?.getAttribute('data-state-zone-code'),
    shipping_city: document.getElementById('shipping_city')?.value,
    shipping_zip_code: document.getElementById('shipping_zip_code')?.value,
    billing_updates: document.getElementById('billing_updates')?.checked,
    b2c_privacy_policy: document.getElementById('b2c_privacy_policy')?.checked
  };

  // Only include billing details if 'billing_updates' is unchecked
  if (!formData.billing_updates) {
    formData.billing_address = {
      billing_address: document.getElementById('b2c-billing-address')?.value,
      billing_address2: document.getElementById('b2c-billing-apartment')?.value,
      billing_country: document.getElementById('b2c-billing-dynamic-country')?.value,
      billing_state: document.getElementById('b2c-billing-dynamic-state').value || document.getElementById('b2c-billing-state').value,
      billing_state_zone_code: document.querySelector('#b2c-billing-dynamic-state option:checked')?.getAttribute('data-state-zone-code'),
      billing_city: document.getElementById('b2c-billing-city')?.value,
      billing_zip_code: document.getElementById('b2c-billing-zip-code')?.value
    };
  }

  let hasErrors = false;

  // Check if all required fields are filled out (basic validation)
  const requiredFields = [
    'email', 'first_name', 'last_name', 'contact', 'shipping_address', 'shipping_country', 'shipping_state', 'shipping_city', 'shipping_zip_code', 'b2c_privacy_policy'
  ];

  requiredFields.forEach(field => {
    const element = document.getElementById(field);
    if (element) {
      if (!formData[field]) {
        element.style.border = "2px solid #ed1818"; // Highlight field in red
        hasErrors = true;
      } else {
        element.style.border = ""; // Remove border if filled
      }
    }
  });

  // Handle state validation separately for Shipping (check only the visible field)
  const shippingStateElement = document.getElementById('shipping_state')?.offsetParent !== null
    ? document.getElementById('shipping_state')
    : document.getElementById('state');

  if (!formData.shipping_state) {
    shippingStateElement.style.border = "2px solid #ed1818";
    hasErrors = true;
  } else {
    shippingStateElement.style.border = "";
  }
  
  // Check billing details if required
  if (!formData.billing_updates) {
    const billingFields = ['b2c-billing-address', 'b2c-billing-dynamic-country', 'b2c-billing-dynamic-state', 'b2c-billing-city', 'b2c-billing-zip-code'];
    billingFields.forEach(field => {
      const element = document.getElementById(field);
      if (element && !formData.billing_address[field]) {
        element.style.border = "2px solid #ed1818"; // Highlight billing fields in red
        hasErrors = true;
      } else if (element) {
        element.style.border = ""; // Remove border if filled
      }
    });
  }

  // Handle state validation separately for Billing (check only the visible field)
  const billingStateElement = document.getElementById('b2c-billing-dynamic-state')?.offsetParent !== null
    ? document.getElementById('b2c-billing-dynamic-state')
    : document.getElementById('b2c-billing-state');

  if (!formData.billing_updates) {
    billingStateElement.style.border = "2px solid #ed1818";
    hasErrors = true;
  } else {
    billingStateElement.style.border = "";
  }

  // ✅ Checkbox Validation - Add Red Border When Not Checked
  const privacyPolicyCheckbox = document.getElementById('b2c_privacy_policy');
  if (!privacyPolicyCheckbox.checked) {
    privacyPolicyCheckbox.style.outline = "2px solid #ed1818";
    privacyPolicyCheckbox.style.height = "auto";
    hasErrors = true;
  } else {
    privacyPolicyCheckbox.style.outline = ""; // Remove outline if checked
  }

  // If errors exist, show generic message and stop form submission
  if (hasErrors) {
    document.querySelector('.B2C-Error-Message').innerHTML = 'Please ensure all required fields are completed before submitting the form.';
    document.querySelector('.B2C-Error-Message').classList.remove('hidden');
    return null;
  }
  
  // Clear any previous errors if validation is passed
  document.querySelector('.B2C-Error-Message').classList.add('hidden');
  return formData;
}

function handleCreateB2CAccountButtonClick(event) {
  event.preventDefault(); // Prevent form submission

  const createB2CAccountButton = document.getElementById('create-account-btn');
  // Disable the button and show loading text
  disableButtonWithLoading(createB2CAccountButton);

  // Collect form data into an object
  const b2cFormData = collectB2CFormData();

  // Make the API call to create the account if form data is valid
  if (b2cFormData) {
    b2cAccountCreate(b2cFormData, createB2CAccountButton);
  } else {
    // If form data is invalid, re-enable the button
    enableButton(createB2CAccountButton);
  }
}

function b2cAccountCreate(data, button) {
  fetch(APP_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
  .then(response => response.json())
  .then(data => {
    if (data?.data?.customerCreate?.customer?.id) {
      // Redirect to a thank you page (or wherever needed)
      window.location.href = `${baseUrl}/pages/thank-you`;
    } else {
      // Check if userErrors exist
      if (Array.isArray(data.data.customerCreate.userErrors) && data.data.customerCreate.userErrors.length > 0) {
        const hasExistingAccountError = data.data.customerCreate.userErrors.some(error => error.message === 'Email has already been taken' || error.message === 'Phone has already been taken');
        
        const errorMessages = data.data.customerCreate.userErrors.map(error => {
          if (hasExistingAccountError) {
            return ACCOUNT_EXIST_MESSAGE;
          }
          return `<li>${error.message}</li>`;
        }).join('');
      
        const errorHeading = hasExistingAccountError ? '<b>It looks like this email and/or phone number is already associated with an existing AliMed account.</b>' : 'The following error(s) must be corrected before continuing:';
      
        document.querySelector('.B2C-Error-Message').innerHTML = `<ul>${errorHeading} ${errorMessages}</ul>`;
        document.querySelector('.B2C-Error-Message').classList.remove('hidden');
      
      } else {
        document.querySelector('.B2C-Error-Message').innerHTML = '<ul><li>An unknown error occurred. Please try again.</li></ul>';
        document.querySelector('.B2C-Error-Message').classList.remove('hidden');
      }
    }
    
    // Enable the button and restore the text after the request is successful
    enableButton(button);
  })
  .catch(error => {
    console.error('Error creating account:', error);
    document.querySelector('.B2C-Error-Message').innerHTML = '<ul><li>There was an issue creating your account. Please try again.</li></ul>';
    document.querySelector('.B2C-Error-Message').classList.remove('hidden');
    
    // Enable the button and restore the text if there is an error
    enableButton(button);
  });
}

/*
* Create an Account B2B  - Company account exists
*/

// Show the company-alimed-section if company_associated is yes
function showCompanyAlimedSection() {
  const continueButton = document.getElementById('account__continue-btn');
  const companyAlimedSection = document.getElementById('company-alimed-section');

  continueButton.classList.add('hidden');
  if (companyAlimedSection) {
    companyAlimedSection.classList.remove('hidden');
  }
}

// Handle company-alimed "Yes" click to show the B2B find company section
function handleCompanyAlimedYesSelection() {
  const companyAlimedYes = document.getElementById('company_alimed_yes');
  const b2bFindCompanySection = document.getElementById('B2B-Find-Company');
  const b2bUserFormDetails = document.getElementById('B2B-User-Form-Details');
  const b2bAccountCreate = document.getElementById('B2B-Account-Create');
  
  if (companyAlimedYes.checked) {
    // Show the B2B Find Company section and hide others
    b2bFindCompanySection.classList.remove('hidden');
    b2bAccountCreate.classList.add('hidden');
    b2bUserFormDetails.classList.add('hidden');
  }
}

// Handle company-alimed "No" click to show the B2B find company section
function handleCompanyAlimedNoSelection() {
  const companyAlimedNo = document.getElementById('company_alimed_no');
  const b2bFindCompanySection = document.getElementById('B2B-Find-Company');
  const b2bUserFormDetails = document.getElementById('B2B-User-Form-Details');
  const b2bAccountCreate = document.getElementById('B2B-Account-Create');
  
  if (companyAlimedNo.checked) {
    // Show the B2B Account Create section and hide others
    b2bAccountCreate.classList.remove('hidden');
    b2bFindCompanySection.classList.add('hidden');
    b2bUserFormDetails.classList.add('hidden');
  }
}

// Handle company search
function handleCompanySearch() {
  const companyId = document.getElementById('company_id').value;

  // Make sure the company_id is not blank
  if (!companyId) {
    alert('Please enter a valid Company ID.');
    return;
  }

  const data = {
    companySearch: true,
    companyId: companyId
  };

  // Make API call to search for the company
  fetch(APP_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
  .then(response => response.json())
  .then(data => {
    const companyResult = data?.data?.[0]?.node;

    // If company is found
    if (companyResult && companyResult.name) {
      document.getElementById('find-company-button').classList.add('hidden');
      document.getElementById('B2B-Company-Result').classList.remove('hidden');
      document.getElementById('B2B-Company-Result').innerHTML = `${companyResult.name} <br> <button id="not-my-company">It’s not my company</button>`;
      document.getElementById('B2B-Company-Result-ID').value = `${companyResult.id}`;
      document.getElementById('B2B-Company-Result-Error').classList.add('hidden');
      document.getElementById('B2B-User-Form-Details').classList.remove('hidden');
      document.querySelector('.find-company').classList.add('hidden');

      // Add the event listener for the "It’s not my company" button here
      const notMyCompanyButton = document.getElementById('not-my-company');
      if (notMyCompanyButton) {
        notMyCompanyButton.addEventListener('click', handleNotMyCompanyClick);
      }
      
    } else {
      document.getElementById('B2B-Company-Result-Error').classList.remove('hidden');
      document.getElementById('B2B-Company-Result-Error').innerHTML = "Couldn't find any company.";
    }
  })
  .catch(error => {
    console.error('Error searching for company:', error);
    alert('There was an issue with the company search. Please try again.');
  });
}

// Handle the "It’s not my company" click
function handleNotMyCompanyClick() {
  const b2bUserFormDetails = document.getElementById('B2B-User-Form-Details');
  const findCompanyButton = document.getElementById('find-company-button');
  const b2bCompanyResult = document.getElementById('B2B-Company-Result');
  
  // Hide the B2B Company Result and User Form Details
  if (b2bCompanyResult) {
    b2bCompanyResult.classList.add('hidden');
  }
  if (b2bUserFormDetails) {
    b2bUserFormDetails.classList.add('hidden');
  }

  document.querySelector('.find-company').classList.remove('hidden');
  if (findCompanyButton) {
    findCompanyButton.classList.remove('hidden');
  }
}

// B2B Exist Company Account Creation process when the create account button is clicked
function handleCreateB2BExistCompanyAccountBtnClick(event) {
  event.preventDefault(); // Prevent form submission

  const B2BExistCompanyAccountBtn = document.getElementById('B2B-Exist-Company-Create-Btn');
  
  // Disable the button and show loading text
  disableButtonWithLoading(B2BExistCompanyAccountBtn);

  // Collect form data into an object
  const existCompanyformData = collectExistCompanyFormData();

  // Make the API call to create the account
  if (existCompanyformData) {
    b2bExistCompanyAccountCreate(existCompanyformData, B2BExistCompanyAccountBtn);
  } else {
    // If form data is invalid, re-enable the button
    enableButton(B2BExistCompanyAccountBtn);
  }
}

// Collect B2B Exist Company form data
function collectExistCompanyFormData() {
  const existCompanyformData = {
    companyUpdate: true,
    companyId: document.getElementById('B2B-Company-Result-ID')?.value,
    email: document.getElementById('exist_company_email')?.value,
    title: document.getElementById('exist_company_title')?.value,
    first_name: document.getElementById('exist_company_first_name')?.value,
    last_name: document.getElementById('exist_company_last_name')?.value,
    contact: document.getElementById('exist_company_contact')?.value,
    department: document.getElementById('exist_company_department')?.value || "",
    job_title: document.getElementById('exist_company_job-title')?.value,
    promo_updates: document.getElementById('exist_company_promo_updates')?.checked ? "SUBSCRIBED" : "NOT_SUBSCRIBED",
    privacy_policy: document.getElementById('b2b_exist_privacy_policy')?.checked
  };

  // const errorMessages = [];
  let hasErrors = false;

  // Check if all required fields are filled out (basic validation)
  const requiredFields = [
    'exist_company_email', 'exist_company_first_name', 'exist_company_last_name', 'exist_company_contact', 'exist_company_job-title', 'b2b_exist_privacy_policy'
  ];

  requiredFields.forEach(field => {
    const element = document.getElementById(field);
    if (element) {
      // For checkboxes, validate differently
      const isCheckbox = element.type === "checkbox";
      const isEmpty = isCheckbox ? !element.checked : !element.value.trim();

      if (isEmpty) {
        element.style.border = "2px solid #ed1818"; // Highlight field in red
        hasErrors = true;
      } else {
        element.style.border = ""; // Remove border if filled
      }
    }
  });

  // ✅ Checkbox Validation - Add Red Border When Not Checked
  const privacyPolicyCheckbox = document.getElementById('b2b_exist_privacy_policy');
  if (!privacyPolicyCheckbox.checked) {
    privacyPolicyCheckbox.style.outline = "2px solid #ed1818";
    privacyPolicyCheckbox.style.height = "auto";
    hasErrors = true;
  } else {
    privacyPolicyCheckbox.style.outline = ""; // Remove outline if checked
  }

  // If there are validation errors, display them and prevent submission
  if (hasErrors) {
    document.querySelector('.B2B-Exist-Company-Error-Message').innerHTML = `Please ensure all required fields are completed before submitting the form.`;
    document.querySelector('.B2B-Exist-Company-Error-Message').classList.remove('hidden');
    return null; // Exit if validation fails
  }

  // Clear any previous errors if validation passes
  document.querySelector('.B2B-Exist-Company-Error-Message').classList.add('hidden');
  return existCompanyformData;
}

// B2B Exist Company Create Account API call
function b2bExistCompanyAccountCreate(data, button) {
  fetch(APP_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
  .then(response => response.json())
  .then(data => {
    if (data?.data?.companyContactCreate?.companyContact?.customer?.id) {
      // Redirect to a thank you page (or wherever needed)
      window.location.href = `${baseUrl}/pages/thank-you-for-registering`;
    } else {
      // Check if userErrors exist
      if (Array.isArray(data?.data?.companyContactCreate?.userErrors) && data?.data?.companyContactCreate?.userErrors.length > 0) {
        const hasExistingAccountError = data.data.companyContactCreate.userErrors.some(error => error.message === 'Email address has already been taken.' || error.message === 'Phone number has already been taken.');
        
        const errorMessages = data?.data?.companyContactCreate?.userErrors.map(error => {
           if (hasExistingAccountError) {
            return ACCOUNT_EXIST_MESSAGE;
          }
          return `<li>${error.message}</li>`;
        }).join('');

        const errorHeading = hasExistingAccountError ? 'It looks like this email and/or phone number is already associated with an existing AliMed account.' : 'The following error(s) must be corrected before continuing:';
        
        document.querySelector('.B2B-Exist-Company-Error-Message').innerHTML = `<ul>${errorHeading} ${errorMessages}</ul>`;
        document.querySelector('.B2B-Exist-Company-Error-Message').classList.remove('hidden');
      } else {
        document.querySelector('.B2B-Exist-Company-Error-Message').innerHTML = '<ul><li>An unknown error occurred. Please try again.</li></ul>';
        document.querySelector('.B2B-Exist-Company-Error-Message').classList.remove('hidden');
      }
    }

    // Enable the button and restore the text after the request is successful
    enableButton(button);
  })
  .catch(error => {
    console.error('Error creating account:', error);
    document.querySelector('.B2B-Exist-Company-Error-Message').innerHTML = '<ul><li>There was an issue creating your account. Please try again.</li></ul>';
    document.querySelector('.B2B-Exist-Company-Error-Message').classList.remove('hidden');
    
    // Enable the button and restore the text if there is an error
    enableButton(button);
  });
}

/*
* Create an Account B2B  - Create new company account
*/

// Dynamic B2B Country and State 
function dynamicB2BCountryStateUpdate() {
  let countrySelect = document.getElementById('create_company_shipping_country');
  let stateInputGroup = document.querySelector('.b2b-form-group__state');
  let dynamicStateGroup = document.querySelector('.b2b-form-group__dynamic-state');
  let dynamicStateSelect = document.getElementById('create_company_shipping_state');

  // Function to handle country selection change
  countrySelect.addEventListener('change', function () {
    let selectedCountry = countrySelect.options[countrySelect.selectedIndex];
    let statesData = selectedCountry.getAttribute('data-states');
    
    if (statesData && statesData !== '[]') {
      // There are states for this country, show dynamic state select
      stateInputGroup.classList.add('hidden');
      dynamicStateGroup.classList.remove('hidden');

      // Parse the states data from the attribute
      try {
        let states = JSON.parse(statesData);
        
        // Clear existing options
        dynamicStateSelect.innerHTML = '<option value="">Select State</option>';

        // Populate the dynamic state select dropdown
        states.forEach(function(state) {
          let option = document.createElement('option');
          option.value = state.state_name;
          option.textContent = state.state_name;
          option.setAttribute('data-state-zone-code', state.state_zone_code);
          dynamicStateSelect.appendChild(option);
        });
      } catch (e) {
        console.error('Error parsing state data:', e);
      }
    } else {
      // No states for this country, show text input for state
      stateInputGroup.classList.remove('hidden');
      dynamicStateGroup.classList.add('hidden');
      dynamicStateSelect.innerHTML = '<option value="">Select State</option>'; // Clear the select options
    }
  });

  // Trigger change event on page load to handle default country
  if (countrySelect.value) {
    countrySelect.dispatchEvent(new Event('change'));
  }
}

// Dynamic B2B Country and State 
function dynamicB2BCountryStateBillingUpdate() {
  let billingCountrySelect = document.getElementById('create_company_billing_country');
  let billingStateInputGroup = document.querySelector('.b2b-form-group__billing-state');
  let dynamicBillingStateGroup = document.querySelector('.b2b-form-group__dynamic-billing-state');
  let dynamicBillingStateSelect = document.getElementById('create_company_billing_state');

  // Function to handle country selection change
  billingCountrySelect.addEventListener('change', function () {
    let selectedCountry = billingCountrySelect.options[billingCountrySelect.selectedIndex];
    let billingStatesData = selectedCountry.getAttribute('data-states');
    
    if (billingStatesData && billingStatesData !== '[]') {
      // There are states for this country, show dynamic state select
      billingStateInputGroup.classList.add('hidden');
      dynamicBillingStateGroup.classList.remove('hidden');

      // Parse the states data from the attribute
      try {
        let billingStates = JSON.parse(billingStatesData);
        
        // Clear existing options
        dynamicBillingStateSelect.innerHTML = '<option value="">Select State</option>';

        // Populate the dynamic state select dropdown
        billingStates.forEach(function(state) {
          let option = document.createElement('option');
          option.value = state.state_name;
          option.textContent = state.state_name;
          option.setAttribute('data-state-zone-code', state.state_zone_code);
          dynamicBillingStateSelect.appendChild(option);
        });
      } catch (e) {
        console.error('Error parsing state data:', e);
      }
    } else {
      // No states for this country, show text input for state
      billingStateInputGroup.classList.remove('hidden');
      dynamicBillingStateGroup.classList.add('hidden');
      dynamicBillingStateSelect.innerHTML = '<option value="">Select State</option>'; // Clear the select options
    }
  });

  // Trigger change event on page load to handle default country
  if (billingCountrySelect.value) {
    billingCountrySelect.dispatchEvent(new Event('change'));
  }
}

const shippingAccountRadioButtons = document.querySelectorAll('input[name="shipping_acount"]');
const collectAccountSection = document.getElementById('B2B-Collect-Account');

// Function to show File upload on basis of tax exempt radio button
function toggleCollectAccountSection() {
  const isShippingAccount = document.querySelector('input[name="shipping_acount"]:checked').value === 'yes';
  if (isShippingAccount) {
    collectAccountSection.classList.remove('hidden');
  } else {
    collectAccountSection.classList.add('hidden');
  }
}

shippingAccountRadioButtons.forEach(radio => {
  radio.addEventListener('change', toggleCollectAccountSection);
});

// Handle B2B Add Company Info Button
function handleCreateB2BAddCompanyInfoBtnClick() {
  document.getElementById('B2B-Add-Company-Info-Btn').classList.add('hidden');
  const b2bCompanyDetails= document.getElementById('B2B-Company-Details');
  b2bCompanyDetails.classList.remove('hidden');

  // B2B billing form details
  const billingCheckbox = document.getElementById('b2b-billing_updates');
  const billingDetails = document.getElementById('B2B-Billing-Details');

  // Add an event listener for the B2B Billing checkbox change
  billingCheckbox.addEventListener('change', function() {
    if (this.checked) {
      // Hide the billing form if checkbox is checked
      billingDetails.classList.add('hidden');
    } else {
      // Show the billing form if checkbox is unchecked
      billingDetails.classList.remove('hidden');
    }
  });
}

// Handle the B2B new company account creation process when the create account button is clicked
function handleCreateB2BNewCompanyAccountBtnClick(event) {
  event.preventDefault(); // Prevent form submission

  const B2BNewCompanyCreateAccountBtn = document.getElementById('B2B-New-Company-Create-Btn');
  
  // Disable the button and show loading text
  disableButtonWithLoading(B2BNewCompanyCreateAccountBtn);

  // Collect form data into an object
  const formData = collectB2BCreateCompanyFormData();

  // Make the API call to create the account
  if (formData) {
    b2bCreateCompanyAccount(formData, B2BNewCompanyCreateAccountBtn);
  } else {
    // If form data is invalid, re-enable the button
    enableButton(B2BNewCompanyCreateAccountBtn);
  }
}

function collectB2BCreateCompanyFormData() {
  const formData = {
    companyCreate: true,
    email: document.getElementById('create_company_email')?.value,
    title: document.getElementById('create_company_title')?.value,
    first_name: document.getElementById('create_company_first_name')?.value,
    last_name: document.getElementById('create_company_last_name')?.value,
    contact: document.getElementById('create_company_contact')?.value,
    department: document.getElementById('create_company_department')?.value || "",
    job_title: document.getElementById('create_company_job_title')?.value,
    promo_updates: document.getElementById('create_company_promo_updates')?.checked ? "SUBSCRIBED" : "NOT_SUBSCRIBED",
    b2b_company_name: document.getElementById('create_company_name')?.value,
    b2b_company_shipping_address: document.getElementById('create_company_shipping_address')?.value,
    b2b_company_shipping_address2: document.getElementById('create_company_apartment')?.value,
    b2b_company_shipping_country: document.getElementById('create_company_shipping_country')?.value,
    b2b_company_shipping_state: document.getElementById('create_company_shipping_state')?.offsetParent !== null 
      ? document.getElementById('create_company_shipping_state').value 
      : document.getElementById('create_company_state').value,
    b2b_company_shipping_state_zone_code: document.querySelector('#create_company_shipping_state option:checked').getAttribute('data-state-zone-code'),
    b2b_company_shipping_city: document.getElementById('create_company_shipping_city')?.value,
    b2b_company_shipping_zip_code: document.getElementById('create_company_shipping_zip_code')?.value,
    b2b_company_default_location: document.getElementById('company-location_updates')?.checked,
    b2b_billing_same_shipping: document.getElementById('b2b-billing_updates')?.checked,
    b2b_company_credit_limit: document.querySelector('input[name="credit_limit"]:checked')?.value,
    b2b_company_shipping_account: document.querySelector('input[name="shipping_acount"]:checked')?.value,
    b2b_company_privacy_policy: document.getElementById('b2b_company_privacy_policy')?.checked,
    locations: []
  };

  if (formData.b2b_company_tax_exempt === 'yes') {
    formData.b2bFileContents = b2bFileContents;
  }

  if (formData.b2b_company_shipping_account === 'yes') {
    formData.b2b_company_collect_account = document.getElementById('create_company_collect_account')?.value;
  }

  if (!formData.b2b_billing_same_shipping) {
    formData.b2b_company_billing_updates = {}; // Initialize empty object first
  
    // Fields to be mapped
    const billingFields = {
      b2b_company_billing_address: 'create_company_billing_address',
      b2b_company_billing_address2: 'create_company_billing_apartment',
      b2b_company_billing_country: 'create_company_billing_country',
       b2b_company_billing_state: document.getElementById('create_company_billing_state')?.offsetParent !== null 
        ? 'create_company_billing_state' 
        : 'create_company_default_state',
      b2b_company_billing_state_zone_code: '#create_company_billing_state option:checked',
      b2b_company_billing_city: 'create_company_billing_city',
      b2b_company_billing_zip_code: 'create_company_billing_zip_code',
    };
  
    // Loop through each field and set the value
    for (const [key, value] of Object.entries(billingFields)) {
      if (Array.isArray(value)) {
        // If multiple elements are considered (like state), take the first available value
        formData.b2b_company_billing_updates[key] = document.getElementById(value[0])?.value || document.getElementById(value[1])?.value || "";
      } else if (value.startsWith('#')) {
        // For selector-based elements, get the attribute
        formData.b2b_company_billing_updates[key] = document.querySelector(value)?.getAttribute('data-state-zone-code') || "";
      } else {
        // For standard ID-based fields
        formData.b2b_company_billing_updates[key] = document.getElementById(value)?.value || "";
      }
    }
  }

  let hasErrors = false;
  const requiredFields = ['email', 'first_name', 'last_name', 'contact', 'job_title', 'b2b_company_name', 'b2b_company_shipping_address', 'b2b_company_shipping_country', 'b2b_company_shipping_state', 'b2b_company_shipping_city', 'b2b_company_shipping_zip_code', 'b2b_company_privacy_policy'];

  // Add Collect Account as a required field
  if (formData.b2b_company_shipping_account === 'yes') {
    requiredFields.push('b2b_company_collect_account');
  }
  
  requiredFields.forEach(field => {
    let element = document.getElementById(`create_company_${field.replace('b2b_company_', '')}`);
    if (field === 'b2b_company_shipping_state') {
      element = document.getElementById('create_company_shipping_state')?.offsetParent !== null 
        ? document.getElementById('create_company_shipping_state') 
        : document.getElementById('create_company_state');
    }
    if (element && !formData[field]) {
      element.style.border = "2px solid #ed1818";
      hasErrors = true;
    } else if (element) {
      element.style.border = "";
    }
  });

  if (!formData.b2b_billing_same_shipping) {
    const billingFields = ['b2b_company_billing_address', 'b2b_company_billing_country', 'b2b_company_billing_state', 'b2b_company_billing_city', 'b2b_company_billing_zip_code'];
    billingFields.forEach(field => {
      let element = document.getElementById(`create_company_${field.replace('b2b_company_', '')}`);
      if (field === 'b2b_company_billing_state') {
        element = document.getElementById('create_company_billing_state')?.offsetParent !== null 
          ? document.getElementById('create_company_billing_state') 
          : document.getElementById('create_company_default_state');
      }
      if (element && !formData.b2b_company_billing_updates[field]) {
        element.style.border = "2px solid #ed1818";
        hasErrors = true;
      } else if (element) {
        element.style.border = "";
      }
    });
  }
  
  // Validate privacy policy checkbox
  const privacyPolicyCheckbox = document.getElementById('b2b_company_privacy_policy');
  if (!privacyPolicyCheckbox.checked) {
    privacyPolicyCheckbox.style.outline = "2px solid #ed1818";
    privacyPolicyCheckbox.style.height = "auto";
    hasErrors = true;
  } else {
    privacyPolicyCheckbox.style.outline = "";
  }

  function isValidUSPhoneNumber(phoneNumber) {
    // Remove all non-numeric characters except leading "+"
    const cleaned = phoneNumber.replace(/[^\d+]/g, "");
    // Regex to validate U.S. phone number format (10-digit, optional +1)
    const phoneRegex = /^(?:\+1)?\d{10}$/;
    return phoneRegex.test(cleaned);
  }

  // Collect & Validate Data for Add Location
  const locationSections = document.querySelectorAll('.location-section');
  locationSections.forEach((section, index) => {
    const locationName = section.querySelector('#company_location_name')?.value.trim();
    const shippingFirstName = section.querySelector('#location_shipping_first_name')?.value.trim();
    const shippingLastName = section.querySelector('#location_shipping_last_name')?.value.trim();
    const shippingContact = section.querySelector('#location_shipping_contact')?.value.trim();
    const shippingAddress = section.querySelector('#company_location_shipping_address')?.value.trim();
    const shippingAddress2 = section.querySelector('#company_location_shipping_apartment')?.value.trim();
    const shippingCountry = section.querySelector('#dynamic_company_location_shipping_country')?.value.trim();
    const shippingState = section.querySelector('#dynamic_company_location_shipping_state')?.offsetParent !== null 
    ? section.querySelector('#dynamic_company_location_shipping_state')?.value 
    : section.querySelector('#company_location_shipping_state')?.value;
    const shippingStateZoneCode = section.querySelector('#dynamic_company_location_shipping_state option:checked')?.getAttribute('data-state-zone-code');
    const shippingCity = section.querySelector('#company_location_shipping_city')?.value.trim();
    const shippingZip = section.querySelector('#company_location_shipping_zip-code')?.value.trim();
    const billingSameAsShipping = section.querySelector('[name="add-location__billing-updates"]')?.checked;
      
    let locationHasErrors = false;
  
    // Required Shipping Fields
    const requiredShippingFields = [
      { id: 'company_location_name', value: locationName },
      { id: 'location_shipping_first_name', value: shippingFirstName },
      { id: 'location_shipping_last_name', value: shippingLastName },
      { id: 'location_shipping_contact', value: shippingContact },
      { id: 'company_location_shipping_address', value: shippingAddress },
      { id: 'dynamic_company_location_shipping_country', value: shippingCountry },
      { id: 'company_location_shipping_city', value: shippingCity },
      { id: 'company_location_shipping_zip-code', value: shippingZip }
    ];
  
    requiredShippingFields.forEach(field => {
      const element = section.querySelector(`#${field.id}`);
      if (element && !field.value) {
        element.style.border = "2px solid #ed1818";
        locationHasErrors = true;
      } else if (element) {
        element.style.border = "";
      }
    });
  
    // Validate Shipping Contact Number
    if (!isValidUSPhoneNumber(shippingContact)) {
      const contactField = section.querySelector('#location_shipping_contact');
      if (contactField) contactField.style.border = "2px solid #ed1818";
      locationHasErrors = true;
    }
  
    let billingData = {};
    
    // If Billing is NOT the same as Shipping, validate and collect billing info
    if (!billingSameAsShipping) {
      const billingFirstName = section.querySelector('#location_billing_first_name')?.value.trim();
      const billingLastName = section.querySelector('#location_billing_last_name')?.value.trim();
      const billingContact = section.querySelector('#location_billing_contact')?.value.trim();
      const billingAddress = section.querySelector('#company_location_billing_address')?.value.trim();
      const billingAddress2 = section.querySelector('#company_location_billing_apartment')?.value.trim();
      const billingCountry = section.querySelector('#dynamic_company_location_billing_country')?.value.trim();
      const billingState = section.querySelector('#dynamic_company_location_billing_state')?.offsetParent !== null 
      ? section.querySelector('#dynamic_company_location_billing_state')?.value 
      : section.querySelector('#company_location_billing_state')?.value;
      const billingStateZoneCode = section.querySelector('#dynamic_company_location_billing_state option:checked')?.getAttribute('data-state-zone-code');
      const billingCity = section.querySelector('#company_location_billing_city')?.value.trim();
      const billingZip = section.querySelector('#company_location_billing_zip-code')?.value.trim();
  
      // Required Billing Fields
      const requiredBillingFields = [
        { id: 'location_billing_first_name', value: billingFirstName },
        { id: 'location_billing_last_name', value: billingLastName },
        { id: 'location_billing_contact', value: billingContact },
        { id: 'company_location_billing_address', value: billingAddress },
        { id: 'dynamic_company_location_billing_country', value: billingCountry },
        { id: 'company_location_billing_city', value: billingCity },
        { id: 'company_location_billing_zip-code', value: billingZip }
      ];
  
      requiredBillingFields.forEach(field => {
        const element = section.querySelector(`#${field.id}`);
        if (element && !field.value) {
          element.style.border = "2px solid #ed1818";
          locationHasErrors = true;
        } else if (element) {
          element.style.border = "";
        }
      });
  
      // Validate Billing Contact Number
      if (!isValidUSPhoneNumber(billingContact)) {
        const contactField = section.querySelector('#location_billing_contact');
        if (contactField) contactField.style.border = "2px solid #ed1818";
        locationHasErrors = true;
      }
  
      // Store Billing Data
      billingData = {
        billingFirstName,
        billingLastName,
        billingContact,
        billingAddress,
        billingAddress2,
        billingCountry,
        billingState,
        billingStateZoneCode,
        billingCity,
        billingZip
      };
    }
  
    // If there are no errors, push location data to formData
    if (!locationHasErrors) {
      formData.locations.push({
        locationName,
        billingSameAsShipping,
        shipping: {
          shippingFirstName,
          shippingLastName,
          shippingContact,
          shippingAddress,
          shippingAddress2,
          shippingCountry,
          shippingState,
          shippingStateZoneCode,
          shippingCity,
          shippingZip
        },
        billing: billingData
      });
    } else {
      hasErrors = true;
    }
  });

  if (hasErrors) {
    document.querySelector('.B2B-New-Company-Error-Message').innerHTML = 'Please ensure all required fields are completed before submitting the form.';
    document.querySelector('.B2B-New-Company-Error-Message').classList.remove('hidden');
    return null;
  }

  document.querySelector('.B2B-New-Company-Error-Message').classList.add('hidden');
  return formData;
}

// B2B New Company Create Account API call
function b2bCreateCompanyAccount(data, button) {
  fetch(APP_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    body: JSON.stringify(data),
  })
  .then(response => response.json())
  .then(data => {

    if (data?.data?.companyCreate?.company?.id) {
      // Redirect to a thank you page (or wherever needed)
      window.location.href = `${baseUrl}/pages/thank-you-for-registering-your-company`;
    } else {
      // Check if userErrors exist
      if (Array.isArray(data?.data?.companyCreate?.userErrors) && data?.data?.companyCreate?.userErrors.length > 0) {
        const hasExistingAccountError = data.data.companyCreate.userErrors.some(error => error.message === 'Email address has already been taken.' || error.message === 'Phone number has already been taken.');
        
        const errorMessages = data?.data?.companyCreate?.userErrors.map(error => {
          if (hasExistingAccountError) {
            return ACCOUNT_EXIST_MESSAGE;
          }
          return `<li>${error.message}</li>`;
        }).join('');

        const errorHeading = hasExistingAccountError ? 'It looks like this email and/or phone number is already associated with an existing AliMed account.' : 'The following error(s) must be corrected before continuing:';
        
        document.querySelector('.B2B-New-Company-Error-Message').innerHTML = `<ul>${errorHeading} ${errorMessages}</ul>`;
        document.querySelector('.B2B-New-Company-Error-Message').classList.remove('hidden');
      } else {
        document.querySelector('.B2B-New-Company-Error-Message').innerHTML = '<ul><li>An unknown error occurred. Please try again.</li></ul>';
        document.querySelector('.B2B-New-Company-Error-Message').classList.remove('hidden');
      }
    }

    // Enable the button and restore the text after the request is successful
    enableButton(button);
  })
  .catch(error => {
    console.error('Error creating account:', error);
    document.querySelector('.B2B-New-Company-Error-Message').innerHTML = '<ul><li>There was an issue creating your account. Please try again.</li></ul>';
    document.querySelector('.B2B-New-Company-Error-Message').classList.remove('hidden');
    
    // Enable the button and restore the text if there is an error
    enableButton(button);
  });
}

// Dynamic state and country update for Add Location section
function initializeDynamicCountryState(locationSection) {
  // Shipping country and state
  const countrySelect = locationSection.querySelector('[name="dynamic_company_location_shipping_country"]');
  const stateInputGroup = locationSection.querySelector('.company-location-shipping__state');
  const dynamicStateGroup = locationSection.querySelector('.company-location-dynamic-shipping__state');
  const dynamicStateSelect = locationSection.querySelector('[name="dynamic_company_location_shipping_state"]');

  // Billing country and state
  const billingCountrySelect = locationSection.querySelector('[name="dynamic_company_location_billing_country"]');
  const billingStateInputGroup = locationSection.querySelector('.company-location-billing__state');
  const dynamicBillingStateGroup = locationSection.querySelector('.company-location-dynamic-billing__state');
  const dynamicBillingStateSelect = locationSection.querySelector('[name="dynamic_company_location_billing_state"]');

  // Function to handle state updates
  function updateStates(countrySelect, stateInputGroup, dynamicStateGroup, dynamicStateSelect) {
    countrySelect.addEventListener('change', function () {
      const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
      const statesData = selectedCountry.getAttribute('data-states');

      if (statesData && statesData !== '[]') {
        // Show dynamic state select
        stateInputGroup.classList.add('hidden');
        dynamicStateGroup.classList.remove('hidden');

        try {
          const states = JSON.parse(statesData);
          dynamicStateSelect.innerHTML = '<option value="">Select State</option>'; // Clear options

          states.forEach(function (state) {
            const option = document.createElement('option');
            option.value = state.state_name;
            option.textContent = state.state_name;
            option.setAttribute('data-state-zone-code', state.state_zone_code);
            dynamicStateSelect.appendChild(option);
          });
        } catch (e) {
          console.error('Error parsing state data:', e);
        }
      } else {
        // Show text input for state
        stateInputGroup.classList.remove('hidden');
        dynamicStateGroup.classList.add('hidden');
        dynamicStateSelect.innerHTML = '<option value="">Select State</option>'; // Clear options
      }
    });

    // Trigger change event on page load to handle default country
    if (countrySelect.value) {
      countrySelect.dispatchEvent(new Event('change'));
    }
  }

  // Initialize shipping and billing states
  if (countrySelect && stateInputGroup && dynamicStateGroup && dynamicStateSelect) {
    updateStates(countrySelect, stateInputGroup, dynamicStateGroup, dynamicStateSelect);
  }

  if (billingCountrySelect && billingStateInputGroup && dynamicBillingStateGroup && dynamicBillingStateSelect) {
    updateStates(billingCountrySelect, billingStateInputGroup, dynamicBillingStateGroup, dynamicBillingStateSelect);
  }
}

// Get references to the button and container
const addLocationBtn = document.getElementById('B2B-Add-Location-Btn');
const locationsContainer = document.getElementById('locations-container');
let isAddingLocation = false; // Flag to prevent multiple clicks

// Function to enable/disable the Add Location button based on location count
function toggleAddLocationButton() {
  let existingLocations = document.querySelectorAll('.location-section-wrapper').length;
  addLocationBtn.disabled = existingLocations >= 5;
}

async function addLocation() {
  if (isAddingLocation || document.querySelectorAll('.location-section-wrapper').length >= 5) {
    return; // Prevent multiple rapid clicks & ensure max 5 locations
  }

  isAddingLocation = true; // Set flag to prevent multiple clicks
  addLocationBtn.disabled = true; // Disable button during fetch

  try {
    const response = await fetch('/pages/create-an-account?view=addLocation');
    const templateHtml = await response.text();

    const locationSection = document.createElement('div');
    locationSection.classList.add('location-section-wrapper');
    locationSection.innerHTML = templateHtml;

    // Append the new location section FIRST
    locationsContainer.appendChild(locationSection);

    // Now count the locations to get a unique index
    let newLocationIndex = document.querySelectorAll('.location-section-wrapper').length;

    // Assign unique ID to the billing checkbox
    const billingCheckbox = locationSection.querySelector('#add-location__billing-updates');
    if (billingCheckbox) {
      let uniqueId = `add-location__billing-updates-${newLocationIndex}`;
      billingCheckbox.id = uniqueId;

      const billingLabel = locationSection.querySelector('label[for="add-location__billing-updates"]');
      if (billingLabel) {
        billingLabel.setAttribute('for', uniqueId);
      }
    }

    // Add event listener to delete the location section
    const deleteButton = locationSection.querySelector('.delete-location-btn');
    deleteButton.addEventListener('click', () => {
      locationsContainer.removeChild(locationSection);
      reorderLocationIds();
      toggleAddLocationButton();
    });

    // Handle show/hide functionality for the billing section
    if (billingCheckbox) {
      const billingDetails = locationSection.querySelector('.add-location__b2b-billing-details');
      billingCheckbox.addEventListener('change', function () {
        if (this.checked) {
          billingDetails.classList.add('hidden');
        } else {
          billingDetails.classList.remove('hidden');
        }
      });
    }

    initializeDynamicCountryState(locationSection);

  } catch (error) {
    console.error("Error adding location:", error);
  } finally {
    isAddingLocation = false; // Reset flag
    toggleAddLocationButton(); // Re-enable the button
  }
}

// Function to reorder billing checkbox IDs after deletion
function reorderLocationIds() {
  document.querySelectorAll('.location-section-wrapper').forEach((section, index) => {
    let newIndex = index + 1;
    const billingCheckbox = section.querySelector('[id^="add-location__billing-updates"]');
    const billingLabel = section.querySelector('label[for^="add-location__billing-updates"]');

    if (billingCheckbox) {
      let newId = `add-location__billing-updates-${newIndex}`;
      billingCheckbox.id = newId;
      if (billingLabel) {
        billingLabel.setAttribute('for', newId);
      }
    }
  });
}

addLocationBtn.addEventListener('click', addLocation);